import React from "react";
import { CheckCircle2 } from "lucide-react";
import ProfileAvatar from "./ProfileAvatar";
import CopyIdButton from "./CopyIdButton";

interface ProfileDisplayProps {
  picture?: string | null;
  name: string;
  username?: string;
  email?: string;
  biography?: string | null;
  id?: string;
  isVerified?: boolean;
  avatarSize?: "xs" | "sm" | "md" | "lg";
}

const ProfileDisplay: React.FC<ProfileDisplayProps> = ({
  picture,
  name,
  username,
  email,
  biography,
  id,
  isVerified = false,
  avatarSize = "xs",
}) => {
  return (
    <div className="flex items-center gap-3">
      <ProfileAvatar picture={picture} name={name} size={avatarSize} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <div
            className="text-base font-bold text-gray-900 truncate"
            style={{ fontSize: "16px", lineHeight: "24px" }}
          >
            {name}
          </div>
          {isVerified && <CheckCircle2 className="w-4 h-4 text-blue-500 flex-shrink-0" />}
        </div>
        {username && (
          <div
            className="text-sm text-gray-500 mt-0"
            style={{ fontSize: "14px", lineHeight: "20px" }}
          >
            @{username}
          </div>
        )}
        {email && (
          <div
            className="text-sm text-gray-500 mt-0"
            style={{ fontSize: "14px", lineHeight: "20px" }}
          >
            {email}
          </div>
        )}
        {biography && <div className="text-sm text-gray-600 mt-1 line-clamp-2">{biography}</div>}
        {id && <CopyIdButton id={id} tooltipId="copy-profile-id-tooltip" />}
      </div>
    </div>
  );
};

export default ProfileDisplay;
